<ng-container [ngSwitch]="linkType">
  <a
    *ngSwitchCase="'routerLink'"
    [routerLink]="taRouterLink"
    [fragment]="fragment"
    [queryParams]="queryParams"
    [class.disabled]="disabled"
    [target]="target"
  >
    <ng-container *ngTemplateOutlet="contentTpl"></ng-container
  ></a>

  <a
    *ngSwitchCase="'href'"
    [href]="href"
    [class.disabled]="disabled"
    [target]="target"
  >
    <ng-container *ngTemplateOutlet="contentTpl"></ng-container
  ></a>

  <a *ngSwitchCase="'empty'" [class.disabled]="disabled">
    <ng-container *ngTemplateOutlet="contentTpl"></ng-container
  ></a>
</ng-container>

<ng-template #contentTpl><ng-content></ng-content></ng-template>
